var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCancelIcon1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 53,
    height: 64,
    viewBox: "0 0 16.91 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_5910",
    "data-name": "Group 5910",
    transform: "translate(-5 -0.472)",
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6180",
    "data-name": "Path 6180",
    d: "M12.976,40.848H6.11A1.111,1.111,0,0,1,5,39.738V35.478A5.483,5.483,0,0,1,10.478,30h2.444a5.379,5.379,0,0,1,.941.083,6.379,6.379,0,0,0-.887,10.765Z",
    transform: "translate(0 -20.376)",
    fill: "#ddd"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6294",
    "data-name": "Rectangle 6294",
    width: 6.23,
    height: 7.12,
    rx: 3.115,
    transform: "translate(8.56 0.472)",
    fill: "#ddd"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2949",
    "data-name": "Ellipse 2949",
    cx: 5.25,
    cy: 5.25,
    r: 5.25,
    transform: "translate(11.41 9.971)",
    fill: "rgba(227,57,60,0.4)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6181",
    "data-name": "Path 6181",
    d: "M6.892,6.892a.459.459,0,0,0,0,.649L8.515,9.165,6.892,10.788a.459.459,0,1,0,.649.649L9.165,9.814l1.623,1.623a.459.459,0,0,0,.649-.649L9.814,9.165l1.623-1.623a.459.459,0,0,0-.649-.649L9.165,8.515,7.541,6.892A.459.459,0,0,0,6.892,6.892Z",
    transform: "translate(7.496 6.057)",
    fill: "#fff"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancelIcon1);
export default __webpack_public_path__ + "static/media/CancelIcon1.12ebd43e5877786cc675d14a7809326d.svg";
export { ForwardRef as ReactComponent };